import React from 'react';
import {makeStyles, Typography} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(5),
        paddingTop: theme.spacing(3),
    },
    title: {
        textAlign: 'center',
        marginTop: theme.spacing(7),
        marginBottom: theme.spacing(3),
    },
    nowrap: {
        whiteSpace: "nowrap",
    },
}));

function MentionLegale() {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Typography variant="h1" className={classes.title}>
                Mention Légale
            </Typography>
            <Typography paragraph variant={"h2"} component={"h2"}>
                Cyklad est édité par :
            </Typography>
            <Typography paragraph>
                Cyklad SAS<br/>
                Société par Actions Simplifiées au capital de <span className={classes.nowrap}>100 000,00 €</span><br/>
                Siège social : 124 Rue des Cèdres, <span className={classes.nowrap}>34980</span> <span
                className={classes.nowrap}>Saint-Clément-de-Rivière</span><br/>
                RCS Montpellier : 898 412 929<br/>
                TVA Communautaire FR00 898 412 929<br/>
                Téléphone : 04 48 20 15 10
            </Typography>
            <Typography paragraph>
                Directeur de la publication : PUECH Vincent
            </Typography>
            <Typography paragraph variant={"h2"} component={"h2"}>
                CNIL :
            </Typography>
            <Typography paragraph>
                Numéro de déclaration :
                Conformément à la loi « informatique et libertés » du 6 janvier 1978 modifiée en 2004, vous bénéficiez
                d’un droit d’accès et de rectification aux informations qui vous concernent, que vous pouvez exercer en
                vous adressant à <a href="mailto:soc@cyklad.fr">soc@cyklad.fr</a>
            </Typography>
            <Typography paragraph>
                Nous vous rappelons que toute copie, même partielle, de quelques éléments que ce soit du site Cyklad
                est interdite. Le non-respect de cette interdiction constitue une contrefaçon susceptible d’engager la
                responsabilité civile et pénale du contrefacteur.
            </Typography>
        </div>
    )
}

export default MentionLegale
